import React from "react";
import * as Icons from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  const { site } = useSite();
  const services = site?.services || [];

  return (
    <section
      data-testid="services-section"
      id="services"
      className="bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-14">
          <span className="overline">Our Services</span>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-bold uppercase leading-tight tracking-tight">
            Full-service <span className="text-[#DC2626]">remodeling</span> for every room
          </h2>
          <p className="mt-4 text-neutral-600 text-lg">
            From quick upgrades to full transformations — one crew, one contract,
            no middlemen. We handle every step.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-l border-neutral-200">
          {services.map((s, i) => {
            const IconEl = Icons[s.icon] || Icons.Hammer;
            return (
              <a
                key={s.id || i}
                href="#contact"
                data-testid={`service-card-${i}`}
                className="group relative bg-white border-r border-b border-neutral-200 p-8 lg:p-10 min-h-[280px] flex flex-col justify-between overflow-hidden hover:bg-neutral-950 transition-colors duration-300"
              >
                {s.image && (
                  <div
                    className="absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-25 transition-opacity duration-500"
                    style={{ backgroundImage: `url(${s.image})` }}
                    aria-hidden
                  />
                )}

                <div className="relative z-10">
                  <div className="w-14 h-14 border-2 border-[#DC2626] flex items-center justify-center mb-6">
                    <IconEl size={26} className="text-[#DC2626]" strokeWidth={2.5} />
                  </div>
                  <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-neutral-900 group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-neutral-600 group-hover:text-neutral-300 text-sm leading-relaxed transition-colors">
                    {s.description}
                  </p>
                </div>

                <div className="relative z-10 mt-6 flex items-center gap-2 font-heading uppercase text-xs tracking-widest text-neutral-900 group-hover:text-[#DC2626] transition-colors">
                  Learn more
                  <ArrowUpRight size={16} strokeWidth={2.5} />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
